module.exports = "/_next/static/images/7b354930a06d54875701d4a07569cd1e-notaxes@3x.jpg.webp";